import React from 'react';

const Contact = () => {
    return (
        <div>
            <h1 className='text-4xl text-center'>Comming soon.</h1>
        </div>
    );
};

export default Contact;